import { Component, ViewChild, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import { MainService } from './core/main.service';
import { AppConfig } from '../environments/environment';
import {BrowserModule, DomSanitizer} from '@angular/platform-browser'
import {Title} from "@angular/platform-browser";
import {Subscription, interval, timer} from 'rxjs';
import { ElectronService } from 'ngx-electron';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  public debug:boolean = false;

  private datasServer:any;
  public datasName:any;
  public base:string;
  public datas:any;

  private activityDelay:number = 5*60*1000; //ms
  private activitySubscription:Subscription;

  public debugTxt:string;

  public isVP:any;
  public current:string = 'loading';
  public step:string;
  public help:boolean;

  public bgImage:any;

  public selected:number = -1;
  public image:any;
  public answers:Array<any>;
  public total:number;
  public total_msg:string;
  public conclusion:string;

  public toknow:string;

  // l'image de la carte
  public w0:number = 1920; // dimensions de la carte
  public h0:number = 1080;
  public x0:number = 876; // position en pixels du centre de la carte (lat=0, long=0)
  public y0:number = 658;
  public scaleX:number = 1700/40000000;
  public scaleY:number = this.scaleX*0.85;

  public minError:number = 1000;

  private espaces:Array<any> = [
  {
    name: 'Végétale',
    color: '#fbab18'
  },
  {
    name: 'Animale',
    color: '#ee4991'
  },
  {
    name: 'Humaine',
    color: '#00aab0'
  },
  {
    name: 'Artificielle',
    color: '#ef4023'
  }
];
public espace = this.espaces[2];

public indexOfSet:number;
public deck:Array<any>;


  @ViewChild('video', {static: false}) videoTag : ElementRef;
  videoProgress:number = 0;

  constructor(
    private service: MainService,
    private sanitizer:DomSanitizer,
    private titleService: Title,
    private electron: ElectronService
  ) {
    this.log('constructor');
  }

  ngOnInit():void
  {
    this.log('ngOnInit');

    if (window.hasOwnProperty('process') && window['process'].hasOwnProperty('versions') && window['process']['versions'].hasOwnProperty('electron')) { // electron
      let response: any = this.electron.ipcRenderer.sendSync('ping');
      this.datasName = response.datas;
      this.service.base = response.base;
      this.base = this.service.base;
    } else {
      this.datasName = this.findGetParameter('datas');
      this.base = AppConfig.datasServer;
    }
    this.log("this.datasName", this.datasName);

    document.addEventListener("click", function () {
        // document.body.requestPointerLock();
    });


    this.checkIfVP();
    this.loadDatas();

    window.addEventListener('idal-contact-event', (e) => {
      let info = e['detail'];
      console.log("Input contact name: " + info.name);
      let port = info.values.findIndex(elt => elt);
      if (port == 0){

      }
    });
  }

  checkIfVP():void
  {
    // Detect Wave System player in VP330 ou VP320
    this.isVP = navigator.userAgent.search("WSPlayer") != -1;
  }

  loadDatas():void
  {
    this.current = 'loading';
    this.service.loadDatas(this.datasName).subscribe((datas => {
      this.datas = datas;

      this.datas.lieux.forEach(lieu => {
        lieu.sanitizedImage = this.sanitizer.bypassSecurityTrustStyle('url('+ this.base+this.datasName+'/files/'+lieu.image +')');
      });

      this.titleService.setTitle( this.datas.name );
      this.start();
    }));
  }

  start():void
  {
    this.bgImage = this.sanitizer.bypassSecurityTrustStyle('url('+ this.base+this.datasName+'/files/'+this.datas.image +')');
    this.goHome();

    // this.selected = 0;
    // this.showEnd();
  }

  showQuestion(num):void
  {
    this.current = 'game';
    this.step = 'question';
    this.selected = num;
    this.help = false;
    this.image = this.sanitizer.bypassSecurityTrustUrl(this.base+this.datasName+'/files/'+this.deck[this.selected].image);
  }
  showEnd():void
  {
    this.current = 'game';
    this.step = 'end';
    this.selected = -1;
    
    let conclusion_msg = this.getComment(this.datas.conclusions, this.total);
    conclusion_msg = this.replaceDatas(conclusion_msg, [{key: 'total', value: this.formatNombre(this.total)}]);
    this.conclusion = conclusion_msg;

    this.toknow = this.replaceDatas(this.datas.toknow, [{key: 'total', value: this.formatNombre(this.total)}]);

    let total_msg = this.replaceDatas(this.datas.total_text, [{key: 'total', value: this.formatNombre(this.total)}]);
    this.total_msg = total_msg;
  }
  onSplashClick():void
  {
    if (AppConfig.name == 'web'){
      if (!document.fullscreenElement){ document.documentElement.requestFullscreen(); }
    }

    this.nextDeck(this.datas.lieux);
    
    this.showIntroduction();
    // this.playVideo({base: this.datas.video}, false);
  }

  nextDeck(datasDeck:Array<any>):void
  {
    let setsIds = [... new Set(datasDeck.map((data) => data.set))].sort();
    if (this.indexOfSet == undefined){
      this.indexOfSet = -1;
    }
    this.indexOfSet = (this.indexOfSet + 1) % setsIds.length;
    this.deck = datasDeck.filter((elt) => elt.set == setsIds[this.indexOfSet]);
    console.log(this.deck);
  }

  goHome():void
  {
    this.clear();
    this.current = 'splash';
  }

  clear():void
  {
    this.answers = [];
    this.total = 0;
    this.selected = -1;
    delete this.image;
    this.answers = [];
    this.total = 0;
    this.conclusion = '';
  }

  findGetParameter(parameterName:string):void
  {
      let result = null,
          tmp = [];
      let items = location.search.substr(1).split("&");
      for (let index = 0; index < items.length; index++) {
          tmp = items[index].split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
      }
      return result;
  }

  onClick():void
  {
    if (this.activitySubscription){
      this.activitySubscription.unsubscribe();
      delete this.activitySubscription;
    }
    this.activitySubscription = timer(this.activityDelay).subscribe(() => {
      this.log("activitySubscription");
      window.location.href = window.location+"index.html";
      // this.current = 'splash';
    });
  }
  onClickBox():void
  {
    if (this.step == 'question'){
      this.step = 'answer';
    } else if (this.step == 'info'){
      if (this.selected+1 < this.deck.length){
        this.showQuestion(this.selected+1);
      } else {
        this.showEnd();
      }
    }
  }
  onClickResult():void
  {
    this.step = 'info';
  }
  onClose():void
  {

  }
  onHelp():void
  {
    this.help = !this.help;
  }
  onClickMap(e:MouseEvent):void
  {
    e.preventDefault();
    if (this.step == 'answer'){
      let pos = {
        x: e.clientX,
        y: e.clientY
      };
      this.onMap(pos);
    }
  }
  onTouchMap(e:TouchEvent):void
  {
    e.preventDefault();
    if (this.step == 'answer'){
      let pos = {
        x: e.touches[0].clientX,
        y: e.touches[0].clientY
      };
      this.onMap(pos);
    }
  }
  onMap(pos):void
  {
    let correct = this.longLat2xy(this.deck[this.selected].position);

    let dx = pos.x - correct.x;
    let dy = pos.y - correct.y;
    let error_px = Math.sqrt(dx*dx + dy*dy);
    let error_angle = Math.acos(dx / error_px);
    if (dy < 0){
      error_angle = -error_angle;
    }
    error_angle += Math.PI;

    let place = this.xy2longLat(pos);
    let error_km = this.distance(place.lat, place.long, this.deck[this.selected].position.lat, this.deck[this.selected].position.long, "K");

    if (error_km < this.minError){
      error_px = 0;
      error_km = 0;
      pos = correct;
    }
    this.total += error_km;
    
    // let error_msg = this.replaceDatas(this.getComment(this.datas.returns, error_km), [{key: 'km', value: this.formatNombre(error_km)}, {key: 'total', value: this.formatNombre(this.total)}]);
    let error_msg = this.getComment(this.datas.returns, error_km);
    error_msg = this.replaceDatas(error_msg, [{key: 'km', value: this.formatNombre(error_km)}, {key: 'total', value: this.formatNombre(this.total)}]);

    let total_msg = this.replaceDatas(this.datas.total_text, [{key: 'total', value: this.formatNombre(this.total)}]);
    this.total_msg = total_msg;


    this.answers.push({
      question: this.deck[this.selected],
      user: pos,
      correct: correct,
      error: {
        km: error_km,
        px: error_px,
        angle: error_angle,
        msg: error_msg
      }
    });

    this.step = "result";

  }

  longLat2xy(long_lat):any
  {
  	let source = 'EPSG:4326'; // coordinates in Longitude/Latitude, WGS84
  	let dest = 'EPSG:3785'; // coordinates in meters, global spherical mercators projection, see http://spatialreference.org/ref/epsg/3785/
  	let result = window['proj4'](source, dest).forward([long_lat.long, long_lat.lat]);

  	let x = result[0];
  	let y = result[1];
  	x = (this.x0 + x * this.scaleX);
  	y = (this.y0 - y * this.scaleY);
  	return {x: x, y: y};
  }
  xy2longLat(x_y):any
  {
  	let x = (x_y.x - this.x0) / this.scaleX;
  	let y = - (x_y.y - this.y0) / this.scaleY;
  	let source = 'EPSG:3785'; // coordinates in meters, global spherical mercators projection, see http://spatialreference.org/ref/epsg/3785/
  	let dest = 'EPSG:4326'; // coordinates in Longitude/Latitude, WGS84
  	let result = window['proj4'](source, dest).forward([x, y]);
  	return {long: result[0], lat: result[1]};
  }
  distance(lat1, lon1, lat2, lon2, unit):number
  {
  	let radlat1 = Math.PI * lat1/180
  	let radlat2 = Math.PI * lat2/180
  	let theta = lon1-lon2
  	let radtheta = Math.PI * theta/180
  	let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  	dist = Math.acos(dist)
  	dist = dist * 180/Math.PI
  	dist = dist * 60 * 1.1515
  	if (unit=="K") { dist = dist * 1.609344 }
  	if (unit=="N") { dist = dist * 0.8684 }
  	return dist
  }
  formatNombre(n:number):string
  {
      let nStr:string = ''+Math.round(n);
      let x = nStr.split('.');
      let x1 = x[0];
      let x2 = x.length > 1 ? '.' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + '&nbsp;' + '$2');
      }
      return x1 + x2;
  }

  getComment(commentsTab:Array<any>, dist:number):string
  {
    let comment;
    commentsTab.sort((a, b) => Math.sign(b.km - a.km)).forEach(elt => {
      console.log(elt.km);
      if (dist <= elt.km){
        comment = elt.text;
      }
    });
    return comment;
  }

  onRestart():void
  {
    this.goHome();
  }

  showIntroduction():void
  {
    this.current = 'introduction';
  }
  onInstructionClick():void
  {
    this.showQuestion(0);
  }

  replaceDatas(text:string, keyPairValues:Array<any>):string{
    console.log(text, keyPairValues);
    keyPairValues.forEach(keyPairValue => {
      let regExp = new RegExp('%'+keyPairValue.key+'%');
      text = text.replace(regExp, keyPairValue.value);
    });
    return text;
  }

  log(...txts:any):void
  {
    if (true || this.isVP){
      this.debugTxt += txts.join(', ');
      this.debugTxt += '<br>';
    } else {
      console.log(...txts);
    }
  }

}
